var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wg-row ticket-menu",staticStyle:{"height":"calc(100vh - 60px)"}},[_c('world-sub-menu',{attrs:{"selected":_vm.pageId,"list":_vm.list},on:{"changePage":_vm.changePage},scopedSlots:_vm._u([{key:"content",fn:function(){return [(_vm.pageId === 'ticketTypes')?_c('ticket-types'):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }